import * as React from "react";

function SvgRefresh(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return <svg viewBox="0 0 16 16" ref={svgRef} {...props}><path d="M3.708 10.751l1.749-1.01L.838 8.042 0 12.891l1.83-1.056a7.59 7.59 0 0014.061-2.751l-2.2-.542C13.061 11.65 11 13.42 8.38 13.42a5.419 5.419 0 01-4.672-2.669zm10.725-7.329a7.591 7.591 0 00-13.328 2.41l2.305.759A4.749 4.749 0 018.38 2.58a5.413 5.413 0 014.366 2.208l-1.563 1.266 4.749.94L16 2.153z" fill="currentColor" fillRule="evenodd" /></svg>;
}

const ForwardRef = React.forwardRef(SvgRefresh);
export default ForwardRef;